module.exports = __webpack_public_path__ + "img/AM.7001ada5.svg";